/**CORE LIBRARIES IMPORT */
import React from "react";
import { motion } from "framer-motion";
import DummyProductImage from "./DummyImage";

const Information = ({
  image,
  title,
  subtitle,
  description,
  bullets = [],
  showGradient = false,
  imageType = "tin",
  category = "JK Metal & Alloys"
}) => {
  return (
    <section className="img-text-section">
      <motion.div 
        className="img-text-wrapper"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
        {/* LEFT IMAGE OR DUMMY PLACEHOLDER */}
        <motion.div 
          className="img-box"
          initial={{ x: -60, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {image ? (
            <img src={image} alt={title} style={{ borderRadius: '12px', width: '100%' }} />
          ) : (
            <DummyProductImage title={title} category={category} type={imageType} />
          )}
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div 
          className={`text-box ${showGradient ? 'has-gradient' : ''}`}
          initial={{ x: 60, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {subtitle && (
            <motion.p 
              className="section-subheading"
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              {subtitle}
            </motion.p>
          )}

          <motion.h2 
            className="section-heading"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            {title}
          </motion.h2>

          <motion.p 
            className="section-text"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          >
            {description}
          </motion.p>

          {bullets && bullets.length > 0 && (
            <ul className="info-bullets">
              {bullets.map((b, idx) => (
                <li key={idx}><strong>{b.title}:</strong> {b.text}</li>
              ))}
            </ul>
          )}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Information;